import { render, staticRenderFns } from "./GifSelector.vue?vue&type=template&id=be8dd5c8&"
import script from "./GifSelector.vue?vue&type=script&lang=js&"
export * from "./GifSelector.vue?vue&type=script&lang=js&"
import style0 from "./GifSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports